module.exports = __webpack_public_path__ + "img/forget.dabc3664.png";